
// Models
import { IMRealStateProduct } from "~/models/RealEstateProduct";

// Types
import { TAmountReturn, TAmounts, TRangeAmounts } from "./types";

/**
 * Get the amount of maturity of project
 * @param realEstateProduct 
 * @returns {number}
 */
export function getCondomminiuMaturity(realEstateProduct: IMRealStateProduct | null = null) {
    try {
        return realEstateProduct?.built_houses &&
            realEstateProduct?.quantity_terrains
            ? ((realEstateProduct?.built_houses || 1) /
            (realEstateProduct?.quantity_terrains || 1)) *
            100
            : 0
    } catch (error) {
        return 0
    }
}

/**
 * Get the best/ideal amount of price and meters from project
 * @param realEstateProduct 
 * @param AMOUNT_BY_METERS 
 * @returns {TAmountReturn}
 */
export function getIdealAmountOfProject(realEstateProduct: IMRealStateProduct | null = null, AMOUNT_BY_METERS: string = ''): TAmountReturn {
    try {
        if (!realEstateProduct?.houses) throw new Error('');

        const rangeAmounts: TRangeAmounts = {};

        // MOUT THE RANGE ESTRUCTURE
        for (let i = 0; i < realEstateProduct.houses.length || 0; i++) {
            const amountRaw = String(
                parseFloat(realEstateProduct.houses[i].vgv.toString() || '0')
            );

            const rangerHouse = {
                vgv: realEstateProduct.houses[i].vgv,
                house_area: realEstateProduct.houses[i].house_area,
                terrain_area: realEstateProduct.houses[i].terrain_area,
            };

            if (amountRaw.length - 1 === 3) {
                const rangerIndex = parseInt(amountRaw.slice(0, 1) + '000');
                const rangerIndexMax = parseInt(amountRaw.slice(0, 1) + '999');

                if (
                rangeAmounts[rangerIndex] &&
                (rangerHouse.vgv >= parseFloat(rangerIndex.toString()) ||
                    rangerHouse.vgv <= parseFloat(rangerIndexMax.toString()))
                ) {
                rangeAmounts[rangerIndex].push(rangerHouse);
                } else {
                rangeAmounts[rangerIndex] = [rangerHouse];
                }
            } else if (amountRaw.length - 1 === 4) {
                const rangerIndex = parseInt(amountRaw.slice(0, 1) + '0000');
                const rangerIndexMax = parseInt(amountRaw.slice(0, 1) + '9999');

                if (
                rangeAmounts[rangerIndex] &&
                (rangerHouse.vgv >= parseFloat(rangerIndex.toString()) ||
                    rangerHouse.vgv <= parseFloat(rangerIndexMax.toString()))
                ) {
                rangeAmounts[rangerIndex].push(rangerHouse);
                } else {
                rangeAmounts[rangerIndex] = [rangerHouse];
                }
            } else if (amountRaw.length - 1 === 5) {
                const rangerIndex = parseInt(amountRaw.slice(0, 1) + '00000');
                const rangerIndexMax = parseInt(amountRaw.slice(0, 1) + '99999');

                if (
                rangeAmounts[rangerIndex] &&
                (rangerHouse.vgv >= parseFloat(rangerIndex.toString()) ||
                    rangerHouse.vgv <= parseFloat(rangerIndexMax.toString()))
                ) {
                rangeAmounts[rangerIndex].push(rangerHouse);
                } else {
                rangeAmounts[rangerIndex] = [rangerHouse];
                }
            } else if (amountRaw.length - 1 === 6) {
                const rangerIndex = parseInt(amountRaw.slice(0, 1) + '000000');
                const rangerIndexMax = parseInt(amountRaw.slice(0, 1) + '999999');

                if (
                rangeAmounts[rangerIndex] &&
                rangerHouse.vgv >= parseFloat(rangerIndex.toString()) &&
                rangerHouse.vgv <= parseFloat(rangerIndexMax.toString())
                ) {
                rangeAmounts[rangerIndex].push(rangerHouse);
                } else {
                rangeAmounts[rangerIndex] = [rangerHouse];
                }
            } else if (amountRaw.length - 1 === 7) {
                const rangerIndex = parseInt(amountRaw.slice(0, 1) + '0000000');
                const rangerIndexMax = parseInt(amountRaw.slice(0, 1) + '9999999');

                if (
                rangeAmounts[rangerIndex] &&
                (rangerHouse.vgv >= parseFloat(rangerIndex.toString()) ||
                    rangerHouse.vgv <= parseFloat(rangerIndexMax.toString()))
                ) {
                rangeAmounts[rangerIndex].push(rangerHouse);
                } else {
                rangeAmounts[rangerIndex] = [rangerHouse];
                }
            }
        }

        let f: TAmounts[] = [];

        // const k = Object.keys(rangeAmounts) as unknown as number[];

        // console.table(k)
        console.table(rangeAmounts)

        // k.fo
        // for (let j = 0; j < k.length; j++) {
        //   if (rangeAmounts[k[j]].length <= 1) continue;

        //   if (f.length <= 0) {
        //     f.push();
        //     continue;
        //   }

        //   if (f && rangeAmounts[k[j]].length > f.length) {
        //     f = rangeAmounts[k[j]];
        //   } else if (j >= 1 && f && rangeAmounts[k[j - 1]].length > f.length) {
        //     f = rangeAmounts[k[j]];
        //   }
        // }

        Object.entries(rangeAmounts).forEach((entry) => entry[1].forEach(amounts => f.push(amounts)))

        console.table(rangeAmounts)
        console.table(f)

        if (f && f.length <= 2) throw new Error();

        // VALOR MEDIO DO VGV
        const houseAmount =
            (f?.reduce(
            (a, b) => {
                let v = 0;
                v = Number(a.vgv) + Number(b.vgv);
                return { vgv: v };
            },
            { vgv: 0 }
            ).vgv || 1) / f.length;

        // AREA PARA CONSTRUÇAO
        const idealArea = Math.round(
            (f?.reduce(
            (a, b) => {
                let v = 0;
                v = Number(a.house_area) + Number(b.house_area);
                return { house_area: v };
            },
            { house_area: 0 }
            ).house_area || 1) / f.length
        )

        // AREA UTILIZADA PARA CONSTRUIR
        const idealAreaBuild = Math.round(
            (f?.reduce(
            (a, b) => {
                let v = 0;
                v = Number(a.terrain_area) + Number(b.terrain_area);
                return { terrain_area: v };
            },
            { terrain_area: 0 }
            ).terrain_area || 1) / f.length
        );

        // DEPRECATED - NOT IN USE ANYMORE
        const HOUSES_AMOUNT_AREA_LENGTH = realEstateProduct?.houses?.reduce(
            (current, a) => {
              const t =
                Number(current.house_area || 0) +
                Number(a.house_area);
      
              return {
                house_area: t,
              };
            },
            { house_area: 0 }
          ).house_area || 1

        // const HOUSE_AMOUNT_AREA = (houseAmount / HOUSES_AMOUNT_AREA_LENGTH) * idealAreaBuild;

        console.log('Range Amount Media: ', houseAmount);
        console.log('Range Ideal Area Media: ', idealArea);
        console.log('Range ideal Area Build Media: ', idealAreaBuild);      

        sessionStorage.setItem('REP@BUILD_DATA', JSON.stringify({
            houseAmount,
            idealArea, // AREA PARA CONSTRUÇAO
            idealAreaBuild ,   // AREA UTILIZADA PARA CONSTRUIR
            AMOUNT_BY_METERS,
            VGV: rangeAmounts
        }))

        return {            
            houseAmount,
            idealArea,
            idealAreaBuild,
        }
    } catch(error: any) {
        return {
            houseAmount: 0,
            idealArea: 0,
            idealAreaBuild: 0
        }
    }
}